
const initialState = {
    booleanResetPasswordModalIsOpen: false,
    booleanRecievePlatformMessages: true,
    booleanResetPasswordEmailSent: false,
}

const settingsReducer = (state = initialState, action) => {

    switch (action.type) {

        case 'RESET_PASSWORD_MODAL':
            return{
                ...state,
                booleanResetPasswordModalIsOpen: action.booleanResetPasswordModalIsOpen,

            }

        case 'RESET_PASSWORD_MODAL_SUCCESSFUL_CLOSING':
            return{
                ...state,
                booleanResetPasswordModalIsOpen: action.booleanResetPasswordModalIsOpen,
                booleanResetPasswordEmailSent: action.booleanResetPasswordEmailSent,
            }

        case 'RESET_PASSWORD_EMAIL_SENT':
            return{
                ...state,
                booleanResetPasswordEmailSent: action.booleanResetPasswordEmailSent,

            }
        
        case 'TOGGLE_RECIEVE_PLATFORM_MESSAGES':

            return {
                ...state,
                booleanRecievePlatformMessages: action.booleanRecievePlatformMessages,
            }
            
        default:
            return state;
    }
    
}


export default settingsReducer
